import { mapActions } from 'vuex'
import Actions from '@/constants/action'
export const common = {
  data() {
    return {
      data: {
        Questions: [
          {
            id: 'Q1',
            label: '1. What kind of support/advice do you want to seek from career consultation?',
            type: 'textarea',
            key: '1582003955000_65812',
            QuestionId: 'Q12P001',
            required: true,
            next: '',
            meta: {
              width: '100%',
              defaultValue: '',
              required: true,
              disabled: false,
              pattern: '',
              placeholder: '',
              next: '',
              remoteFunc: 'func_1582003955000_65812'
            },
            options: []
          },
          {
            id: 'Q2',
            label: '2. Please upload your latest CV.',
            type: 'fileupload',
            key: '1581665397000_78487',
            QuestionId: 'Q12P002',
            required: true,
            next: '',
            meta: {
              defaultValue: [],
              size: { width: 100, height: 100 },
              width: '',
              tokenFunc: 'funcGetToken',
              token: '',
              domain: '',
              disabled: false,
              length: 1,
              multiple: true,
              isQiniu: false,
              required: true,
              isDelete: false,
              isEdit: false,
              action: '',
              next: '',
              remoteFunc: 'func_1581665397000_78487'
            },
            options: []
          },
          {
            'id': 'Q3',
            'label': '条款协议',
            'formatLabel': '我已填写完毕所有信息（包括个人信息）, 我同意<a href="https://youplusapplication.businesstrainingshpwc.com/application/TermsOfUse.html" target="_blank">&nbsp;使用条款&nbsp;</a>和<a href="https://youplusapplication.businesstrainingshpwc.com/application/PrivacyStatement.html" target="_blank">&nbsp;隐私条款&nbsp;</a>。',
            'type': 'checkbox',
            'key': '1584529120000_22039',
            'desc': '',
            'QuestionId': 'PCLAUSE',
            'required': true,
            'next': '',
            'meta': {
              'inline': false,
              'defaultValue': [],
              'showLabel': false,
              'options': [
                {
                  'id': 'PCLAUSEo60182',
                  'value': '我同意',
                  'label': '我同意',
                  'next': ''
                }
              ],
              'required': true,
              'width': '',
              'remote': false,
              'remoteOptions': [],
              'props': {
                'value': 'value',
                'label': 'label'
              },
              'remoteFunc': 'func_1584529120000_22039',
              'disabled': false,
              'next': ''
            },
            'options': [
              {
                'id': 'PCLAUSEo60182',
                'value': '我同意',
                'label': '我同意',
                'next': ''
              }
            ]
          }
        ],
        Title: 'Career Counselling Application',
        InternalTitle: 'Career Counselling Application',
        Description: ''
      },
      fileKeys: [],
      formData: {}
    }
  },
  computed: {
  },
  created() {
    this.initFormData()
    // this.logout()
  },
  methods: {
    ...mapActions({
      logout: Actions.LOGOUT
    }),
    initFormData() {
      this.formData = {}
      this.data.Questions.forEach(item => {
        this.$set(item, 'hidden', false)
        if (item.type === 'checkbox') {
          this.$set(this.formData, item.key, [])
        } else if (item.type === 'rate') {
          this.$set(this.formData, item.key, 0)
        } else if (item.type === 'number') {
          this.$set(this.formData, item.key, 1)
        } else {
          this.$set(this.formData, item.key, '')
        }
        if (item.type === 'radio' || item.type === 'select') {
          item.options.forEach(op => {
            if (op.id.endsWith('Other')) {
              this.$set(this.formData, item.key + 'Other', '')
            }
          })
        }
      })
      this.fileKeys = this.data.Questions.map(item => {
        if (item.type === 'imgupload' || item.type === 'fileupload') {
          return item.key
        }
      }).filter(item => item)
    }
  }
}
